import { Directive, Input } from "@angular/core";
import { NzCellFixedDirective } from "ng-zorro-antd/table";

@Directive({
  selector: "td[uiRight],th[uiRight],td[uiLeft],th[uiLeft]",
})
export class UiCellFixedDirective extends NzCellFixedDirective {
  @Input("uiRight") public nzRight: string | boolean = false;
  @Input("uiLeft") public nzLeft: string | boolean = false;
  @Input("colspan") public colspan: number | null = null;
  @Input("colSpan") public colSpan: number | null = null;
}
